export default "__VITE_ASSET__CEPtMZcu__"